/**
 * Public social profiles, per chapter.
 *
 * Single source of truth for the websites, the admin and the email
 * templates' social rows.
 */

import { type Chapter } from "./chapters";

export interface ChapterSocials {
  instagramUrl: string | null;
  facebookUrl: string | null;
  twitterUrl: string | null;
  youtubeUrl: string | null;
  /** A wa.me link to the chapter's public number, or null. */
  whatsappUrl: string | null;
}

export const CHAPTER_SOCIALS = {
  aus: {
    instagramUrl: "https://www.instagram.com/vyaustralia/",
    facebookUrl: "https://www.facebook.com/profile.php?id=100077464998148",
    twitterUrl: null,
    youtubeUrl: null,
    whatsappUrl: null,
  },
  // The NZ chapter has no dedicated social presence yet — surfaces that
  // read this render nothing rather than linking to the AUS accounts.
  nz: {
    instagramUrl: null,
    facebookUrl: null,
    twitterUrl: null,
    youtubeUrl: null,
    whatsappUrl: null,
  },
  sg: {
    instagramUrl: "https://www.instagram.com/vihangam_yoga_singapore",
    facebookUrl: "https://facebook.com/vihangamyogasingapore",
    twitterUrl: "https://twitter.com/vysingapore1",
    youtubeUrl: "https://www.youtube.com/vihangamyogasingapore",
    whatsappUrl: "https://wa.me/6590117690",
  },
} satisfies Record<Chapter, ChapterSocials>;

/** Socials for a chapter, defaulting to the Australian chapter. */
export function chapterSocials(chapter: Chapter = "aus"): ChapterSocials {
  return CHAPTER_SOCIALS[chapter];
}
